<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="linespace" id="ded"> </p>
<p class="ded"><span epub:type="pagebreak" id="pg_v" title="v">For the many friends I rely on when I stray into areas beyond my experience – they know who they are – and whose patience, kindness and advice I value greatly.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2d986838